import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-blue-900 to-blue-800 text-white mt-20">
      <div className="max-w-6xl mx-auto px-3 py-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">P&M DREAM MANORS</h3>
            <p className="text-sm text-blue-100 mb-2">Private Limited</p>
            <p className="text-gray-300 text-sm">
              Your trusted partner in finding premium properties. We specialize in residential, 
              commercial, and luxury real estate solutions.
            </p>
            <div className="mt-4">
              <p className="text-xs text-blue-200">CIN: [Your Company CIN]</p>
              <p className="text-xs text-blue-200">RERA Reg: [Your RERA Number]</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-gray-300 hover:text-white transition duration-200 text-sm">
                  Home
                </a>
              </li>
              <li>
                <a href="/offers" className="text-gray-300 hover:text-white transition duration-200 text-sm">
                  Special Offers
                </a>
              </li>
              <li>
                <a href="/category/rent" className="text-gray-300 hover:text-white transition duration-200 text-sm">
                  Properties for Rent
                </a>
              </li>
              <li>
                <a href="/category/sale" className="text-gray-300 hover:text-white transition duration-200 text-sm">
                  Properties for Sale
                </a>
              </li>
              <li>
                <a href="/about" className="text-gray-300 hover:text-white transition duration-200 text-sm">
                  About Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start">
                <FaEnvelope className="mt-1 mr-2 text-blue-300" />
                <span className="text-gray-300">info@pmdreammanors.com</span>
              </li>
              <li className="flex items-start">
                <FaPhone className="mt-1 mr-2 text-blue-300" />
                <span className="text-gray-300">+91-9091928787</span>
              </li>
              <li className="flex items-start">
                <FaMapMarkerAlt className="mt-1 mr-2 text-blue-300 flex-shrink-0" />
                <span className="text-gray-300">
                  C/O SUSHIL KUMAR LOHIYA, PATH CHOTI RUKANPURA, Patna Aerodrome, Phulwari, Patna- 800014, Bihar<br />
                  Patna, Bihar, India
                </span>
              </li>
            </ul>
            <div className="mt-4">
              <p className="text-xs text-blue-200">Working Hours:</p>
              <p className="text-xs text-gray-300">Mon - Sat: 9:00 AM - 6:00 PM</p>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Connect With Us</h4>
            <p className="text-gray-300 text-sm mb-4">
              Follow us on social media for latest property updates and offers.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-2xl hover:text-blue-400 transition duration-200">
                <FaFacebook />
              </a>
              <a href="#" className="text-2xl hover:text-blue-400 transition duration-200">
                <FaTwitter />
              </a>
              <a href="#" className="text-2xl hover:text-pink-400 transition duration-200">
                <FaInstagram />
              </a>
              <a href="#" className="text-2xl hover:text-blue-400 transition duration-200">
                <FaLinkedin />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-blue-700 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-center text-sm">
            <p className="text-gray-300">
              &copy; 2025 P&M Dream Manors Private Limited. All rights reserved.
            </p>
            <div className="flex space-x-4 mt-3 md:mt-0">
              <a href="#" className="text-gray-300 hover:text-white transition duration-200">
                Privacy Policy
              </a>
              <span className="text-gray-500">|</span>
              <a href="#" className="text-gray-300 hover:text-white transition duration-200">
                Terms of Service
              </a>
              <span className="text-gray-500">|</span>
              <a href="#" className="text-gray-300 hover:text-white transition duration-200">
                Disclaimer
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
